import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, interval } from 'rxjs';
import { Store } from '@ngrx/store';
//
// Services
//
import { DealerDetailService } from '../../../services/api/dealer-detail.service';
import { SharedFunctionService } from '../../../services/common/shared-function.service';
import { DDFeatureConfigService } from 'src/app/shared/service/common/dd-feature-config.service';
//
// Models
//
import * as models from '../../../shared/models';
//
// Store Actions
//
import * as fromRootStore from '../../../store';
import * as sharedDataActions from '../../../store/actions/shared-data.action';
import {
  MenuActionEnableDetaiMenuItems,
  MenuActionSetActive
} from '../../../store/actions/menu.action';

import { OmnitureTags } from 'src/app/shared/omnitureTags';
import { decode } from 'html-entities';
import { TOTAL_OPTIONAL_EQUIPMENT } from '../../../shared/constants';
import { NOT_APPLICABLE } from '../../../shared/constants/app.constants';
import { LoaderService } from '../../../services/common/loader.service';

@Component({
  providers: [OmnitureTags],
  selector: 'dd-v-spec-detail',
  templateUrl: './v-spec-detail.html',
  styleUrls: ['./v-spec-detail.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VSpecDetail implements OnInit, OnDestroy {


  // Observable to save inventory screen data
  sharedDataStore$: Observable<models.SharedData>;
  // Subscriber for Shared Data Store
  sharedDataStoreSubscriber: any;
  dealerConfigSub: any;
  // Field to store Shared Data from store
  sharedData: models.SharedData = <models.SharedData>{};
  dealerDetailsLoaded$ = new BehaviorSubject<boolean>(false);
  vehicleDetails: any;
  dealerDetails: any;
  vin: any;
  dealerCd: any;
  deleteVin: boolean = false;
  mpgDetails: any = null;
  vehicleInfoNotFound = false;
  vehicleInfoNotFoundMessage = "Page you are looking for is not found!";
  vehicleInfoNotFoundDirection = "Please contact dealer for more information.";
  incompleteVehicle = false;
  vehicleInfoIncompleteMessage = "VSPEC is not available until required Vehicle details are available."
  vehicleInfoIncompleteDirection = "Please try again later.";
  exteriorLabels = [];
  factoryaccessoriesTotalPrice: number = 0.00;
  portaccessoriesTotalPrice: number = 0.00;
  distributoraccessoriesTotalPrice: number = 0.00;
  dealerInstalledaccessoriesTotalPrice: number = 0.00;
  dealerAdjustments: number = 0.00;
  isDios: boolean = false;
  isSmartPathDealer: boolean = false;
  isGST: boolean = false;
  htmlRegEx = /(\[([^\]]+)\]|<([^>]+)>)/gi;
  isGas: boolean = false;
  isElectric: boolean = false;
  isHybrid: boolean = false;
  tsrpDisclaimer: string = '';
  baseMsrpDisclaimer: string = '';
  isOwningDealer: boolean = false;
  isLexus: boolean = false;
  protected readonly TOTAL_OPTIONAL_EQUIPMENT = TOTAL_OPTIONAL_EQUIPMENT;

  ngOnInit() {
    this.dealerDetailService.getFormattedDealerDetails;
    this.vehicleInfoNotFound = false;

    this.sharedDataStoreSubscriber = this.sharedDataStore$.subscribe(data => {
      this.sharedData = Object.assign({}, data);
    });

    this.activatedRoute.data.subscribe((resolverData: any) => {
      if (resolverData && resolverData.data) {
        this.assignData(resolverData.data);
        this.sharedData.currentVin = this.vin;
        this.sharedData.dealerDetails = this.dealerDetails;
        this.dispatchActions();
        this.loaderService.isLoading$.next(false);
      } else {
        this.vehicleInfoNotFound = true;
        this.loaderService.isLoading$.next(false);
      }
    });
  }

  assignData(resolvedData) {
    const {
      vehicleDetails,
      dealerDetails,
      dealerCd,
      vin,
      isDios,
      isElectric,
      isGST,
      isGas,
      isHybrid,
      isSmartPathDealer,
      dealerInstalledaccessoriesTotalPrice,
      distributoraccessoriesTotalPrice,
      portaccessoriesTotalPrice,
      factoryaccessoriesTotalPrice,
      dealerAdjustments,
      baseMsrpDisclaimer,
      tsrpDisclaimer,
      mpgDetails
    } = resolvedData;
    this.vehicleDetails = vehicleDetails;
    this.dealerDetails = dealerDetails;
    this.dealerCd = dealerCd;
    this.vin = vin;
    this.isDios = isDios;
    this.isElectric = isElectric;
    this.isGST = isGST;
    this.isGas = isGas;
    this.isHybrid = isHybrid;
    this.isSmartPathDealer = isSmartPathDealer;
    this.dealerInstalledaccessoriesTotalPrice = dealerInstalledaccessoriesTotalPrice;
    this.distributoraccessoriesTotalPrice = distributoraccessoriesTotalPrice;
    this.portaccessoriesTotalPrice = portaccessoriesTotalPrice;
    this.factoryaccessoriesTotalPrice = factoryaccessoriesTotalPrice;
    this.dealerAdjustments = dealerAdjustments;
    this.baseMsrpDisclaimer = baseMsrpDisclaimer;
    this.tsrpDisclaimer = tsrpDisclaimer;
    this.mpgDetails = mpgDetails;

    this.isOwningDealer = vehicleDetails.dealerCd === dealerDetails.dealerCode;
    this.isLexus = dealerDetails.isLexus;
  }

  dispatchActions() {
    this.store.dispatch(new sharedDataActions.SetSharedDataAction(this.sharedData));
    this.store.dispatch(new MenuActionEnableDetaiMenuItems({
      hidden: false,
      routerLink: 'Detail'
    }));

    this.store.dispatch(new MenuActionSetActive(<any>{ label: 'Detail' }));
  }

  optionsFilter(opt) {
    if (opt.optionType === "L" || opt.optionType === "F") {
      return this._formatPrice(opt.msrp);
    } else if(opt.optionType === "D") {
      return (this.isSmartPathDealer || this.isGST)
        ? this._formatPrice(opt.dealerSellingPrice)
        : '****';
    }

    return this._formatPrice(opt.msrp);
  }

  private _formatPrice(number) {
    if (number === NOT_APPLICABLE) {
      return NOT_APPLICABLE;
    }

    return (
      '$' +
      parseInt(number || 0, 10).toLocaleString('en-us', { minimumFractionDigits: 2 })
    );
  }

  removeSpecialChars(input: string): string {
    return decode(input).replace(this.htmlRegEx, '').replace('‑', '-');
  }

  /***
     * For removing the html code from the data
     */
  formatMarketingNames(data: string) {
    // remove any url is present in the string
    if (data !== null && data !== undefined && data.indexOf('.com') !== -1) {
      data = data.replace(/\(.*?\)/g, '');
    }
    if (data !== null && data !== undefined && data.indexOf('[') !== -1) {
      data = data.replace(/\[.*?\]/g, '');
    }
    return data;
  }

  ngOnDestroy() {
    if (this.sharedDataStoreSubscriber) {
      this.sharedDataStoreSubscriber.unsubscribe();
    }
    if (this.dealerConfigSub) {
      this.dealerConfigSub.unsubscribe();
    }
  }

  constructor(
    public store: Store<fromRootStore.IAppState>,
    public sharedFunctionService: SharedFunctionService,
    public omTag: OmnitureTags,
    public _FeatureConfigService: DDFeatureConfigService,
    private dealerDetailService: DealerDetailService,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService
  ) {
    this.loaderService.isLoading$.next(true);
    this.sharedDataStore$ = store.select(fromRootStore.SharedDataStore);
  }

  installedOptSubscription: any;
  installedOptionsAction(event: any) {

    if(event.visible && this.installedOptSubscription == null) {
      this.installedOptSubscription = interval(2500)
      .subscribe(x => {
        this.omTag.fireOmnitureTag('vd_aa-subpageload_packages_accessories_module', null, this.sharedData);
        this.installedOptSubscription.unsubscribe();
        //this.installedOptSubscription = null;
      });
    } else if(!event.visible && this.installedOptSubscription != null) {
      this.installedOptSubscription.unsubscribe();
      //this.installedOptSubscription = null;
    }
  }

  featuresSubscription: any;
  featuresAction(event: any) {

    if(event.visible && this.featuresSubscription == null) {
      this.featuresSubscription = interval(2500)
      .subscribe(x => {
        this.omTag.fireOmnitureTag('vd_aa-subpageload_features_module', null, this.sharedData);
        this.featuresSubscription.unsubscribe();
        //this.featuresSubscription = null;
      });
    } else if(!event.visible && this.featuresSubscription != null) {
      this.featuresSubscription.unsubscribe();
      //this.featuresSubscription = null;
    }
  }
}
